import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { Gem } from "@fleet/icons";
import { appRoute } from "./route";
import { PageContainer } from "@fleet/ui/page-container";
import { PageHeader } from "@fleet/ui/page-header";
import { PlanOverview } from "@/features/billing/components/plan-overview";
import { useI18n } from "@/providers/i18n-provider";

function PlanPage() {
  const { t } = useI18n();
  return (
    <PageContainer maxWidth="4xl" class="space-y-8">
      <PageHeader
        title={t(msg`Plan & usage`)}
        description={t(msg`The plan of your congregation and what it is using.`)}
        backTo="/profile"
        icon={Gem}
      />
      <PlanOverview />
    </PageContainer>
  );
}

export const profilePlanRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/profile/plan",
  component: PlanPage,
});
